import React from 'react';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { addressesSelector, housesSelector } from '../../../../store/selectors';
import useRequestAddresses from '../../../../../../queries/useRequestAddresses';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';

const SelectAddresses = ({ className }) => {
  const dispatch = useDispatch();
  const selectedHouses = useSelector(housesSelector);
  const selectAddresses = useSelector(addressesSelector);

  const { data: addresses, isFetching } = useRequestAddresses(
    selectedHouses[0],
    {
      staleTime: Infinity,
      enabled: Boolean(selectedHouses.length),
    }
  );

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.addresses, value }));
  };

  return (
    <Select
      onChange={handleChange}
      className={className}
      loading={isFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear={true}
      placeholder="Кв/офис"
      value={selectAddresses}
      optionFilterProp="searchtext"
    >
      {addresses?.map((address) => (
        <Select.Option
          key={address.id}
          value={address.id}
          searchtext={address.name}
        >
          {address.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectAddresses;
